import { environment } from "@/env/env.prod";
import Cookies from "js-cookie";
import type { AIGuideCategory, AIGuideDocument } from "./AIGuide.types";

class AIGuideService {
    baseApi: string;

    constructor() {
        this.baseApi = `${environment.BASE_URL}/aiGuide`;
    }

    getHeaders() {
        return {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("authToken")}`,
            "X-INSTITUTE": Cookies.get("ins_code"),
            "X-E-ID": Cookies.get("E_id"),
            "X-FACULTY": Cookies.get("Fac") || "1",
            "X-PARENT": Cookies.get("ins_code"),
        };
    }

    async fetchAllDocuments(): Promise<{ success: boolean; byCategory: Record<AIGuideCategory, AIGuideDocument> }> {
        const res = await fetch(`${this.baseApi}/fetchAllDocuments`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        return res.json();
    }

    async saveDocument(category: AIGuideCategory, content: string, isActive: boolean) {
        const res = await fetch(`${this.baseApi}/saveDocument`, {
            method: "POST",
            headers: this.getHeaders(),
            body: JSON.stringify({ category, content, isActive }),
        });
        return res.json();
    }
}

export default AIGuideService;
